import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';

export const Cell = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex-grow: 1;
    padding: 8px 0px;
`;

/** Identifiers must never break mid-number — "95504434876 225" reads as two numbers. */
export const IdCell = styled(Cell)`
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
`;

/** Holds a row's three-dot menu, right-aligned in the last column. */
export const ActionsCell = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
    color: ${Variables.ThemeLight.TextMild};
`;

export const Breadcrumbs = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 4px;
    color: ${Variables.Colors.n70};
`;

/** States what the backend answered for the list below — a missing endpoint, or unconfirmed scoping. */
export const Notice = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 10px 14px;
    border-radius: 8px;
    background: ${Variables.ThemeLight.AttentionMild3};
    color: ${Variables.ThemeLight.AttentionInverted3};
    font-size: 13px;
    line-height: 1.45;
`;

/** An endpoint, query parameter or error code, set apart so it can be copied into a ticket. */
export const Code = styled.code`
    font-size: 12px;
    word-break: break-all;
`;

export const NoticeTitle = styled.strong`
    font-weight: ${Variables.FontWeight.semibold};
`;

/** The expanded row under an ERA claim: its charge lines. Same shape as the guarantors sub-row. */
export const Charges = styled.div`
    padding: 4px 24px 20px 56px;
`;

export const ChargesTable = styled.table`
    border-collapse: collapse;
    color: ${Variables.Colors.n100};
    font-size: 13px;
`;

export const ChargesTH = styled.th`
    text-align: left;
    padding: 6px 20px 6px 0;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.Colors.n70};
    white-space: nowrap;
`;

export const ChargesTD = styled.td`
    padding: 6px 20px 6px 0;
    vertical-align: top;
    white-space: nowrap;
`;

/** Right-aligned so the charge / paid / adjustment columns read as a sum. */
export const ChargesMoney = styled(ChargesTD)`
    text-align: right;
    font-variant-numeric: tabular-nums;
`;
